import { css } from '@emotion/react';
import { atoms } from '@zapier/marketing-ui';
import { Icon } from '@zapier/zinnia-icons';
import { FC, ReactNode } from 'react';
import { VisuallyHidden } from 'react-aria-components';

const requirementStyle = css`
  display: flex;
  align-items: start;
  gap: 4px;
`;

/** Text for the state the aria-hidden icons convey (SC 1.1.1). */
export const requirementMetLabel = 'Met:';
export const requirementNotMetLabel = 'Not met:';

type PasswordRequirementProps = {
  children: ReactNode;
  requirementIsSatisfied?: boolean;
  testId: string;
};

const PasswordRequirement: FC<PasswordRequirementProps> = ({
  children,
  requirementIsSatisfied,
  testId,
}) => {
  const name = requirementIsSatisfied ? 'formCheck' : 'formX';
  const color = requirementIsSatisfied
    ? 'StatusSuccessStrongest'
    : 'StatusErrorStrongest';

  return (
    <div data-testid={testId} css={requirementStyle}>
      <Icon name={name} color={color} size={20} />
      <p className={`${atoms.bodySM} ${atoms.textNeutral800}`}>
        <VisuallyHidden elementType="span">
          {requirementIsSatisfied
            ? `${requirementMetLabel} `
            : `${requirementNotMetLabel} `}
        </VisuallyHidden>
        {children}
      </p>
    </div>
  );
};

export default PasswordRequirement;
